import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

import type { RootState } from "../root/config.store";
import { type Config, initialState } from "../../types/configuration";

// slice
export const configurationSlice = createSlice({
  name: "configuration",
  initialState,
  reducers: {
    fetchAllisLoading(state) {
      state.loading = true;
    },
    fetchAllSucceeded(state, action: PayloadAction<Config[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAllFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

// Actions
export const configurationActions = {
  fetchAll: createAction(`${configurationSlice.name}`),
  fetchAllisLoading: configurationSlice.actions.fetchAllisLoading,
  fetchAllSucceeded: configurationSlice.actions.fetchAllSucceeded,
  fetchAllFailure: configurationSlice.actions.fetchAllFailure,
};

// Selectors
export const selectconfiguration = (state: RootState): Config[] =>
  state.configuration.data;

// Reducer
export default configurationSlice.reducer;
